var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useAccountSummaryV2Query, } from "@syf-api-library/account-summary";
import { useAutopayStatusQuery, } from "@syf-api-library/autopay-status";
import { useAccountActivityQuery, } from "@syf-api-library/account-activity";
import { useContext } from "react";
import MainContext from "../ui/Context";
import useApiConfig from "./useApiConfig";
export var useAccountSummary = function (enabled) {
    if (enabled === void 0) { enabled = true; }
    var accountId = useContext(MainContext).selectedAccountId;
    var queryOptions = { useErrorBoundary: true };
    var apiConfig = useApiConfig(enabled, queryOptions);
    return useAccountSummaryV2Query(__assign({ keyProps: {
            accountId: accountId,
            /**
             * This type is needed since account numbers are encoded as guid from the accounts api and
             * account summary api needs the type in order to convert them to usable account numbers
             */
            accountIdType: "guid",
        } }, apiConfig));
};
export var useAutopayStatus = function (enabled) {
    if (enabled === void 0) { enabled = true; }
    var accountId = useContext(MainContext).selectedAccountId;
    var queryOptions = { useErrorBoundary: true };
    var apiConfig = useApiConfig(enabled, queryOptions);
    return useAutopayStatusQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid" } }, apiConfig));
};
export var useAccountActivity = function (enabled) {
    var accountId = useContext(MainContext).selectedAccountId;
    var queryOptions = { useErrorBoundary: true };
    var apiConfig = useApiConfig(enabled, queryOptions);
    return useAccountActivityQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid" } }, apiConfig));
};
//# sourceMappingURL=syfApiQueries.js.map